module.exports = __webpack_public_path__ + "img/logoh5.d80e011c.png";